/* LED-BOX — cronometrul campaniei Black Friday.

   Porneste orice element [data-lb-bf-ceas] cu atributul data-lb-bf-tinta, o
   data ISO 8601 cu fus orar explicit (ex. 2026-11-06T00:00:00+02:00). Fusul
   trebuie scris in data: fara el, browserul o citeste in ora locala a
   vizitatorului si clientii din alt fus vad alt cronometru decat noi.

   Cand tinta trece, elementul primeste .lb-bf--expirat si, daca are
   data-lb-bf-reincarca, pagina se reincarca o singura data ca sa treaca de la
   "incepe in" la "se termina in" fara ca omul sa dea refresh.
*/
(function () {
  'use strict';

  var ceasuri = [].slice.call(document.querySelectorAll('[data-lb-bf-ceas]'));
  if (!ceasuri.length) return;

  function doua(n) { return n < 10 ? '0' + n : String(n); }

  function porneste(el) {
    var tinta = Date.parse(el.getAttribute('data-lb-bf-tinta'));
    if (isNaN(tinta)) return;

    var camp = {
      z: el.querySelector('[data-bf-zile]'),
      o: el.querySelector('[data-bf-ore]'),
      m: el.querySelector('[data-bf-min]'),
      s: el.querySelector('[data-bf-sec]')
    };
    var reincarcat = false;

    function tick() {
      var rest = tinta - Date.now();

      if (rest <= 0) {
        el.classList.add('lb-bf--expirat');
        if (el.hasAttribute('data-lb-bf-reincarca') && !reincarcat) {
          reincarcat = true;
          /* Mica intarziere: daca mai multe ceasuri expira in acelasi tick,
             nu vrem mai multe reincarcari suprapuse. */
          setTimeout(function () { location.reload(); }, 1200);
        }
        clearInterval(t);
        return;
      }

      var sec = Math.floor(rest / 1000);
      var zile = Math.floor(sec / 86400);
      var ore = Math.floor((sec % 86400) / 3600);
      var min = Math.floor((sec % 3600) / 60);
      var s = sec % 60;

      if (camp.z) camp.z.textContent = zile;
      if (camp.o) camp.o.textContent = doua(ore);
      if (camp.m) camp.m.textContent = doua(min);
      if (camp.s) camp.s.textContent = doua(s);
    }

    tick();
    var t = setInterval(tick, 1000);
  }

  ceasuri.forEach(porneste);
})();
